import { UPDATE_EVENT } from "./types";

const updateEvent = (event) => ({
  type: UPDATE_EVENT,
  event,
});

export default updateEvent;
